<nav [ngClass]="{'hidden-nav': !navVisible}">
    <div class="sidebar-toggle-spacer">
        <div class="sidebar-toggle" (click)="toggleSidebar()">
            <span class="material-symbols-rounded">
                left_panel_close
            </span>
        </div>

        <div class="sidebar-container" *ngIf="hasNavData(); else loading">

            <div class="mobile-search-container">
                <input type="text" id="searchInput" placeholder="QUICK SEARCH" [(ngModel)]="searchInput" />
                <span class="material-symbols-rounded search-icon"> search </span>
                <button class="mobile-search-button" (click)="submitSearchInput()">Go</button>
            </div>

            <ul class="accordion-flush">
                @if( contentType === 'api' ) {
                    <div class="domain-toggle" [formGroup]="navForm">
                        <apl-ui-form-radio-card
                            [options]="[
                                { id: 'core', label: 'Core', icon: navForm.get('selectedDomain')?.value === 'core' ? 'check' : undefined },
                                { id: 'ally', label: 'Ally', icon: navForm.get('selectedDomain')?.value === 'ally' ? 'check' : undefined }
                            ]"
                            display="segmented-full-width"
                            formControlName="selectedDomain"/>
                    </div>
                }
                <li>
                    <h2 class="nav-header-row">
                        <div class="api-version">
                            API Version
                            <div class="version-number" *ngIf="contentType === 'api'">
                                <select [(ngModel)]="selectedVersion" (ngModelChange)="onVersionChange($event)">
                                    <option *ngFor="let v of versionsForSelectedDomain" [value]="v">{{ v }}</option>
                                </select>
                            </div>
                        </div>

                        <label class="theme-toggle" title="Toggle theme">
                            <input type="checkbox" (click)="toggleTheme()">
                            <span class="theme-toggle-sr">Toggle theme</span>
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="1em" height="1em"
                                class="theme-toggle__dark-side" fill="currentColor" viewBox="0 0 32 32">
                                <path
                                    d="M16 .5C7.4.5.5 7.4.5 16S7.4 31.5 16 31.5 31.5 24.6 31.5 16 24.6.5 16 .5zm0 28.1V3.4C23 3.4 28.6 9 28.6 16S23 28.6 16 28.6z" />
                            </svg>
                        </label>
                    </h2>

                    <div class="accordion-body">
                        <!-- Data-driven navigation component -->
                        <app-nav-items
                            #navItemsComponent
                            [contentType]="contentType"
                            [groupedNavItems]="groupedNavItems"
                            [docsNavItems]="docsNavItems"
                            [activeItem]="activeItem"
                            [activeGroup]="activeGroup"
                            [activeCategoryId]="activeCategoryId"
                            (groupExpanded)="onGroupExpand()">
                        </app-nav-items>
                    </div>

                </li>
            </ul>

            <div class="sidebar-static-nav"
                [ngClass]="currentTheme === 'dark-mode' ? 'static-dark-mode' : 'static-light-mode'">
                <p class="mobile-static-link-subeader">More Topics</p>
                <ul>
                    <li *ngIf="contentType === 'api'"> <a class="mobile-static-link-title" routerLink="/">Home</a> </li>
                    <li *ngIf="contentType === 'api'"> <a class="mobile-static-link-title" routerLink="/docs">Docs</a> </li>

                    <li *ngIf="contentType === 'docs'"> <a class="mobile-static-link-title" routerLink="/docs">Docs Home</a> </li>
                    <li *ngIf="contentType === 'docs'"> <a class="mobile-static-link-title" routerLink="/">API Explorer</a> </li>

                    <li> <a class="mobile-static-link-title" routerLink="/support">Support</a> </li>
                    <li *ngIf="displayRecipes"> <a class="mobile-static-link-title" routerLink="/r">Recipes</a> </li>

                    <div class="accordion-body" *ngIf="currentTheme">
                        <div #sideNavClientLibraryAccordion="ngbAccordion" ngbAccordion [closeOthers]="true"
                            class="client-library-accordion">
                            <ng-container *ngFor="let entry of librariesByType | keyvalue">
                                <div ngbAccordionItem [collapsed]="true">
                                    <h2 ngbAccordionHeader>
                                        <button class="sidebar-nav sidebar-title" ngbAccordionButton>
                                            {{ entry.key === 'ClientLibrary' ? 'Client Libraries' : 'AndDone
                                            FrameWorks' }}
                                        </button>
                                    </h2>

                                    <div ngbAccordionCollapse>
                                        <div ngbAccordionBody class="client-library-accordion-content">
                                            <h6 class="client-library-title">
                                                {{ entry.key === 'ClientLibrary' ?
                                                'Jump to the GitHub repository for the libraries and installation
                                                instructions.' :
                                                'Jump to the GitHub repository, then follow the instructions to get
                                                started in minutes.'
                                                }}
                                            </h6>

                                            <ul class="sidebar-client-library-links">
                                                <ng-container *ngFor="let lib of entry.value">
                                                    <ng-container *ngIf="lib && getThemeIcons(lib) as icon">
                                                        <li (mouseenter)="hoveredLib = lib.id"
                                                            (mouseleave)="hoveredLib = null">
                                                            <a *ngIf="lib.RepositoryURL; else staticIcon" target="_blank"
                                                                [href]="lib.RepositoryURL">
                                                                <img [src]="hoveredLib === lib.id ? icon.Hover?.url : icon.Default?.url"
                                                                    [title]="lib.Language + ' Client Library'"
                                                                    [alt]="icon.Default?.alternativeText || (lib.Language + ' Client Library')" />
                                                            </a>

                                                            <ng-template #staticIcon>
                                                                <span>
                                                                    <img [src]="hoveredLib === lib.id ? icon.Hover?.url : icon.Default?.url"
                                                                        [title]="lib.Language + ' Client Library (Unavailable)'"
                                                                        [alt]="icon.Default?.alternativeText || (lib.Language + ' Client Library')"
                                                                        style="cursor: default; opacity: 0.7;" />
                                                                </span>
                                                            </ng-template>
                                                        </li>
                                                    </ng-container>
                                                </ng-container>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                </ul>
            </div>

        </div>

        <ng-template #loading>
            <p>Loading data...</p>
        </ng-template>
    </div>
</nav>